import mainMenuItems from './mainMenuItems';
import { NavItemType } from 'types/menu';

const menuItems: { items: NavItemType[] } = {
  items: [mainMenuItems]
};

export default menuItems;
